import { UxaContextStorageService } from './uxa-context-storage.service';
export var RedirectionTarget;
(function (RedirectionTarget) {
    RedirectionTarget["AI_ALERTS"] = "alerts/notifications";
    RedirectionTarget["BENCHMARK"] = "covid-workspace";
    RedirectionTarget["EXPERIENCE_STUDIO"] = "xstudio";
    RedirectionTarget["GLOBAL_PARAMETERS"] = "project-settings/global-parameters";
    RedirectionTarget["GOALS"] = "define/goals";
    RedirectionTarget["INSIGHTS"] = "auto-insights";
    RedirectionTarget["JOURNEY_ANALYSIS"] = "analyze/navigation-path";
    RedirectionTarget["JS_ERROR_ANALYSIS"] = "js-errors";
    RedirectionTarget["MAPPINGS"] = "define/mappings";
    RedirectionTarget["PAGE_COMPARATOR"] = "analyze/pages-comparator";
    RedirectionTarget["PERSONAL_SETTINGS"] = "personal-settings/profile";
    RedirectionTarget["SCREEN_METRICS"] = "analyze/screen-metrics";
    RedirectionTarget["SEGMENTS"] = "define/segments";
    RedirectionTarget["SESSION_REPLAY"] = "session-replay";
    RedirectionTarget["SITE_OVERVIEW"] = "site-overview";
    RedirectionTarget["WORKSPACE"] = "dashboard";
    RedirectionTarget["ZONING_ANALYSIS"] = "analyze/zoning-v2";
    RedirectionTarget["ZONING_EDITOR"] = "analyze/zoning-v2/:id/editor";
})(RedirectionTarget || (RedirectionTarget = {}));
export class UxaRedirectionService {
    constructor() { }
    async createUrl(projectId, target, csState, path, query) {
        let url = `#/${target}${path ? path : ''}`;
        if (!query) {
            query = {};
        }
        query = Object.assign(Object.assign({}, query), { projectId });
        if (csState) {
            const contextHash = csState ? await UxaContextStorageService.get().saveContext(csState) : '';
            query.hash = contextHash;
        }
        const queryString = this.getQueryString(query);
        url += queryString !== '' ? `?${queryString}` : '';
        return url;
    }
    getQueryString(params) {
        if (!params) {
            return '';
        }
        const parse = (v) => {
            if (v instanceof Array) {
                return v.join(',');
            }
            if (v instanceof Date) {
                return v.toISOString();
            }
            return encodeURIComponent(v);
        };
        return Object.entries(params)
            .filter((e) => e[1] != null)
            .reduce((query, e) => query + `${e[0]}=${parse(e[1])}&`, '');
    }
    async redirect(projectId, target, csState, openInNewTab = false) {
        const url = await this.createUrl(projectId, target, csState);
        const windowName = openInNewTab ? '_blank' : '_self';
        if (target === RedirectionTarget.SESSION_REPLAY) {
            localStorage.setItem('shortcutsRedirect', JSON.stringify(true));
        }
        setTimeout(() => {
            window.open(url, windowName);
        }, 1000);
    }
}
//# sourceMappingURL=uxa-redirection.service.js.map